import { adminHttpClient } from '../../commons/adminHttpClient'

export type AddProductToCompanyInterface = {
  productId: number
  planCode: string
  groupHealthPlanName?: string
  groupHealthStartDate?: string
  discountCode?: string
}

const addProductToCompany = (payload: AddProductToCompanyInterface): Promise<any> => {
  return adminHttpClient.post('/Companies/AddProductToCompany', payload)
}

export default addProductToCompany
